import { Action } from '@skylab-shared/types';

import { ModelBase } from '../../model';
import { HandlerContext } from './business-object-base';

export class CoreFeatureManager {
    private readonly actions: Action<HandlerContext<any>>[];

    public constructor() {
        this.actions = [];
    }

    public listen<TModel extends ModelBase = ModelBase, TContext extends HandlerContext<TModel> = HandlerContext<TModel>>(action: Action<TContext>): void {
        this.actions.push(<Action<HandlerContext<any>>>action);
    }

    public processCoreFeatures<TModel extends ModelBase, TContext extends HandlerContext<TModel>>(context: TContext): void {
        this.actions.forEach(action => action(context));
    }
}
